// Lightweight logger — no-op in production builds so debug lines never leak
// into browser consoles of real users. `error` always runs so we still see
// hard failures in production. Use `debug(...)` in place of `console.debug`
// and `warn(...)` for non-fatal issues you want to keep visible in dev.

const isDev = process.env.NODE_ENV !== "production";

export const debug = (...args) => {
  if (isDev && typeof console !== "undefined") {
    // eslint-disable-next-line no-console
    console.debug(...args);
  }
};

export const warn = (...args) => {
  if (isDev && typeof console !== "undefined") {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
};

export const error = (...args) => {
  // Always surface errors — production consoles show them via Sentry-like
  // hooks or the browser DevTools of the user reporting an issue.
  if (typeof console !== "undefined") {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};
